import { render, staticRenderFns } from "./DetailVoucher.vue?vue&type=template&id=49d56a74"
import script from "./DetailVoucher.vue?vue&type=script&lang=js"
export * from "./DetailVoucher.vue?vue&type=script&lang=js"
import style0 from "./DetailVoucher.vue?vue&type=style&index=0&id=49d56a74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports